import { render } from "./Auth2faActivate.vue?vue&type=template&id=614dd326&scoped=true"
import script from "./Auth2faActivate.vue?vue&type=script&lang=js"
export * from "./Auth2faActivate.vue?vue&type=script&lang=js"

import "./Auth2faActivate.vue?vue&type=style&index=0&id=614dd326&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-614dd326"]])

export default __exports__